import React from 'react'

import { Separator } from '@components/Separator'
import { useFindProfile } from '@hooks/profile'

import { InfoContainer, Label, SectionTitle, SubTitle } from './styles'

export function UserInformation() {
  const { data: rawUser } = useFindProfile()
  const user = rawUser ?? ({} as NonNullable<typeof rawUser>)

  const roles = {
    'global-admin': 'Global Admin',
    mechanical: 'Mechanical',
    technician: 'Technician',
    flsupervisor: 'FL Supervisor',
    scheduler: 'Scheduler',
    process: 'Process',
    admin: 'Admin',
    read: 'Read',
  }

  const userRoles = user.selectedSite.roles
    .map((role) => roles[role])
    .join(', ')

  return (
    <>
      <SectionTitle>User Information</SectionTitle>
      <Separator mb={10} />

      <InfoContainer>
        <SubTitle>Email</SubTitle>
        <Label>{user.email}</Label>
      </InfoContainer>
      {user.isGlobalAdmin && (
        <InfoContainer>
          <SubTitle>Global Admin</SubTitle>
        </InfoContainer>
      )}
      <InfoContainer>
        <SubTitle>Roles</SubTitle>
        <Label>{userRoles}</Label>
      </InfoContainer>
    </>
  )
}
